// extracted by mini-css-extract-plugin
module.exports = {"notFound":"CardsContainer_notFound__3g3lG","cardsContainer":"CardsContainer_cardsContainer__1Cnrw","link":"CardsContainer_link__2CPCz"};